const apac = require('./apac');
const rse = require('./rse');
const dermato = require('./dermato');
const ecg = require('./ecg');
const eeg = require('./eeg');
const estomato = require('./estomato');
const teleconsultorias = require('./teleconsultorias');
const tfd = require('./tfd');
const tfdPassagens = require('./tfdPassagens');
const oauth2 = require('./oauth2');
const exames = require('./exames');
const comum = require('./comum');
const administrativo = require('./administrativo');
const teleEducacao = require('./teleEducacao');
const mensagens = require('./mensagens');
const alofono = require('./alofono');
const analise = require('./analise');
const espiro = require('./espiro');
const teleatendimento = require('./teleatendimento');
const teleatendimentoFhir = require('./teleatendimentoFhir');
const meusExames = require('./meusExames');
const polissonografia = require('./polissonografia');
const helpdesk = require('./helpdesk');
const oxigenoterapia = require('./oxigenoterapia');
const valida = require('./valida');
const conecta = require('./conecta');
const nexus = require('./nexus');
const dra = require('./dra');
const buscaAtiva = require('./buscaAtiva');
const gestaoPacs = require('./gestaoPacs');
const contrarreferencia = require('./contrarreferencia');
const patologia = require('./patologia');
const retinografia = require('./retinografia');
const console = require('./console');

module.exports = {
    administrativo,
    alofono,
    analise,
    apac,
    buscaAtiva,
    comum,
    conecta,
    console,
    contrarreferencia,
    dermato,
    ecg,
    nexus,
    dra,
    eeg,
    espiro,
    estomato,
    exames,
    gestaoPacs,
    helpdesk,
    mensagens,
    meusExames,
    oauth2,
    oxigenoterapia,
    patologia,
    polissonografia,
    retinografia,
    teleatendimento,
    teleatendimentoFhir,
    teleconsultorias,
    teleEducacao,
    tfd,
    tfdPassagens,
    valida,
    rse
};
